/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    SubjectFileDTO,
    SubjectFileDTOFromJSON,
    SubjectFileDTOFromJSONTyped,
    SubjectFileDTOToJSON,
} from './SubjectFileDTO';

/**
 * 
 * @export
 * @interface SubjectFileDTOPagedResponse
 */
export interface SubjectFileDTOPagedResponse {
    /**
     * 
     * @type {number}
     * @memberof SubjectFileDTOPagedResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof SubjectFileDTOPagedResponse
     */
    pageSize?: number;
    /**
     * 
     * @type {number}
     * @memberof SubjectFileDTOPagedResponse
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<SubjectFileDTO>}
     * @memberof SubjectFileDTOPagedResponse
     */
    data?: Array<SubjectFileDTO> | null;
}

export function SubjectFileDTOPagedResponseFromJSON(json: any): SubjectFileDTOPagedResponse {
    return SubjectFileDTOPagedResponseFromJSONTyped(json, false);
}

export function SubjectFileDTOPagedResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubjectFileDTOPagedResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'page': !exists(json, 'page') ? undefined : json['page'],
        'pageSize': !exists(json, 'pageSize') ? undefined : json['pageSize'],
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'data': !exists(json, 'data') ? undefined : (json['data'] === null ? null : (json['data'] as Array<any>).map(SubjectFileDTOFromJSON)),
    };
}

export function SubjectFileDTOPagedResponseToJSON(value?: SubjectFileDTOPagedResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'page': value.page,
        'pageSize': value.pageSize,
        'totalCount': value.totalCount,
        'data': value.data === undefined ? undefined : (value.data === null ? null : (value.data as Array<any>).map(SubjectFileDTOToJSON)),
    };
}

